module.exports = __webpack_public_path__ + "img/lg_ring_r_c_0_1@2x.e415a0f1.png";